<template>
  <div :class="['custom-group','custom-is-group',{'notRoot':!isRoot, 'custom-group-first': isFirst}]">
    <div class="deleteBtn" v-if="!isRoot" @click="deleteCondition">
      <div class="deleteBar"></div>
    </div>
    <div class="custom-title">
      <span class="size-12 mr-10 mrMd">满足下列</span>
      <span class="custom-title-select">
        <el-select v-model="defaultCondition.relationType" @change="onChangeRelation" size="small">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </span>
    </div>
    <div class="custom-child" :class="{'custom-scroll scrollbar': isRoot}" ref="customChild">
      <div class="custom-wrap custom-pseudo">
        <template v-for="(item, index) in conditionValue">
          <custom-tree-group :type="item.cn" v-if="item.childOption" :key="item.myId" :index="index" :firstIndex="item.myId" :data="item" @change="onNodeChange" @delete="onDelete" />
          <custom-tree-sub-group v-else :key="item.myId" :index="index" :firstIndex="item.myId" :data="item" @change="onNodeChange" @delete="onDelete" @addCondition="addCondition" />
        </template>
        <div class="custom-tree-node custom-node-line custom-new custom-pseudo" :class="{'no-after': !conditionValue.length}">
          <el-button class="group-add" type="text" size="mini" @click="addCondition">
            <span><i class="el-icon-plus"></i>添加条件</span>
          </el-button>
          <el-button class="group-add" v-if="isRoot" type="text" size="mini" @click="addGroup">
            <span><i class="el-icon-plus"></i>添加条件组</span>
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import customTreeSubGroup from './subGroup';
import uniqueId from 'lodash/uniqueId';
export default {
  name: 'customTreeGroup',
  components: {
    customTreeSubGroup,
  },
  props: ['isRoot', 'data', 'index', 'type'],
  data() {
    return {
      options: [
        {
          label: '全部条件',
          value: 2
        },
        {
          label: '任一条件',
          value: 1
        },
      ],

      conditionValue: null,
      isChangeTemplate: false,//是否改变值
      defaultCondition: null
    }
  },
  computed: {
    isFirst() {
      if (this.isRoot) return false
      const defaultCondition = this.$store.getters.getDefaultCondition
      const vos = defaultCondition.conditionVos[0]
      if (vos.childOption && this.data.myId === vos.myId) {
        return true
      }
      return false
    }
  },
  created() {
    if (this.isRoot) {
      this.defaultCondition = this.$store.getters.getDefaultCondition
      // 搜索树
      this.conditionValue = this.defaultCondition.conditionVos

      window.aaa = this.defaultCondition
    } else {
      this.defaultCondition = this.data.childOption
      this.conditionValue = this.defaultCondition.conditionVos
      window.bbb = this.defaultCondition

    }
  },
  methods: {
    deleteCondition() {
      const defaultCondition = this.$store.getters.getDefaultCondition
      const index = defaultCondition.conditionVos.findIndex(e => {
        return e.myId === this.data.myId
      })
      defaultCondition.conditionVos.splice(index, 1)
     
      this.getSetDefaultCondition()
    },
    onBottom() {
      this.$nextTick(e => {
        this.$refs.customChild.scrollTop = this.$refs.customChild.scrollHeight
      })
    },
    addCondition() {

      if (this.conditionValue.length > 19) {
        this.$message.error('最多只可添加20个筛选条件')
        return
      }
      // 添加节点
      this.$store.commit('setSingleId')
      let singleCondition = this.$store.getters.getSingleCondition

      this.conditionValue.push(singleCondition)
      this.onBottom()
    },
    addGroup() {
      const group = this.conditionValue.filter(e => e.childOption)
      if (group.length > 2) {
        this.$message.error('最多只可添加3个筛选条件')
        return
      }
      // 添加条件组
      this.$store.commit('setGroupId')
      let defaultGroup = this.$store.getters.getGroupCondition
      this.conditionValue.push(defaultGroup)
      this.onBottom()

    },
    onChangeRelation(val) {
      this.defaultCondition.relationType = val
      this.getSetDefaultCondition()
    },
    onNodeChange() {

    },
    onDelete(index, firstIndex) {
      // 删除dom节点
      this.conditionValue.splice(index, 1)
      // todo 删除数据
    },
    // 本地存储默认条件
    getSetDefaultCondition(){
      let source = this.$store.getters.getDefaultCondition
      console.log('满足',this.$store.getters.getDefaultCondition)
      localStorage.setItem('inputDefaultCondition',JSON.stringify(source),1)
    }
  },
}
</script>
<style lang="scss" scoped>
.custom-node-line {
  position: relative;
}
.custom-pseudo:after,
.custom-pseudo:before {
  content: "";
  display: block;
  position: absolute;
}
.custom-group {
  height: 100%;
  // overflow: hidden;
  display: flex;
  align-items: center;
  padding-left: 24px;
}
.custom-is-group {
  border-top: 1px solid #EEEEEE;
  border-left: 1px solid #EEEEEE;
  display: flex;
  .deleteBtn {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    background: #fff;
    border: 2px solid #5088FF;
    border-radius: 50% 50%;
    margin-right: 8px;
    display: inline-block;
    cursor: pointer;
    position: relative;
    left: 0;
    top: 0;
    .deleteBar {
      width: 8px;
      height: 2px;
      background: #5088FF;
      position: absolute;
      top: 5px;
      left: 2px;
    }
  }
  .custom-title {
    width: 193px;
  }
  .custom-child {
    flex-grow: 1;
  }
}

.notRoot {
  position: relative;
  &::before {
    content: "";
    display: block;
    position: absolute;
    width: 24px;
    height: 0;
    border-bottom: 1px dashed #d9d9d9;
    left: 0;
    top: 50%;
  }
  &::after {
    content: "";
    display: block;
    position: absolute;
    width: 0;
    height: 100%;
    border-left: 1px dashed #d9d9d9;
    left: 0;
    top: 0;
  }
}
.custom-title {
  white-space: nowrap;
  position: relative;
  padding-right: 28px;
  &::after {
    content: "";
    display: block;
    position: absolute;
    right: 0;
    top: 50%;
    // width: 20px;
    width: 29px;
    height: 0;
    border-bottom: 1px dashed #d9d9d9;
  }
  .size-12 {
    font-size: 13px;
  }
  .group-condition-node {
    width: 90px;
  }
}
.custom-scroll {
  height: 100%;
  flex: 1;
  overflow: auto;
}
.custom-wrap {
  min-height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.el-select {
  // width: 110px;
  width: 104px;
  box-sizing: border-box;
}
.group-add {
  // color: #999;
  color: #5088FF;
  padding-left: 2px;
}
.group-add:hover {
  // color: #4181ff;
  color: #5088FF;
}
.custom-new {
  padding: 12px 0 12px 40px;
}
.custom-new:before {
  width: 24px;
  height: 0;
  border-bottom: 1px dashed #d9d9d9;
  left: 0;
  top: 50%;
}
.custom-new:after {
  width: 0;
  height: 100%;
  border-left: 1px dashed #d9d9d9;
  left: 0;
  top: -50%;
}
.no-after::after {
  display: none;
}
.custom-group-first::after {
  content: "";
  display: block;
  position: absolute;
  height: 50%;
  width: 0;
  border-left: 1px dashed #d9d9d9;
  left: 0;
  top: 50%;
}
.group-condition-node {
  width: 90px;
  .el-icon-arrow-up {
    transform: none !important;
    position: relative;
    left: 4px;
    &::before {
      content: "\E790";
    }
  }
}

.group-condition-node {
  .el-input {
    font-size: 12px;
  }
  .el-input__inner {
    padding: 0 8px;
    border-radius: 2px;
  }
  .popper__arrow {
    display: none;
  }

  .el-popper {
    left: 0px !important;
    margin-top: 0px !important;
  }
}
.icon-arrows {
  z-index: 1;
}

.select-root-option {
  top: 30px !important;
  .el-select-dropdown__item.selected {
    background: none;
  }
  .el-select-dropdown__item.hover {
    background: none;
  }
  .el-select-dropdown__item:hover {
    background-color: #fff2ea;
  }
  .el-select-dropdown__item {
    padding: 0 16px;
  }
}
.custom-title{
    .mrMd{
      margin-right: 8px;
    }
}
::v-deep {
  .custom-title-select {
    position: relative;
    .el-input.is-focus .el-input__inner {
      box-shadow: none;
    }
    .el-select .el-input .el-select__caret{
      line-height: 36px;
    }
  }
    .custom-new{
      .el-icon-plus{
           margin-right: 6px;
           &::before{
             font-size: 12px;
             font-weight: bold;
           }
      }
      .group-add{
        margin-right: 30px;
      }
    }
    .custom-group{
        .el-input--small .el-input__inner{
           height: 36px;
          //  line-height: 36px;
           box-shadow: none;
           box-sizing: border-box;
           font-size: 13px;
        }
    }
    .custom-is-group.notRoot{
           border-top: none;
          border-left: none;
    }
}
.custom-pseudo{
      .group-add{
           span{
             color: #5088FF;
             font-size: 13px;
           } 
     }
}
</style>
<style lang="scss">
  .el-select-dropdown__list{
    padding-bottom: 0;
  }
</style>